import store from '../store';
import axios from "axios";
import defaultSetting from "../config/apiConfig";

const getRequestHeader = () => Object.assign(defaultSetting.requestHeader, {Authorization: `Bearer ${store.state.auth.token}`});
const getFileRequestHeader = () => Object.assign(defaultSetting.fileRequestHeader, {Authorization: `Bearer ${store.state.auth.token}`});

const puller = async (url, params = "") =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}${url}`,
        headers: getRequestHeader(),
        params: params
    });

const poster = async (url, payload) => 
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}${url}`,
        headers: getRequestHeader(),
        data: payload
    });

const filePoster = async (url, payload) =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}${url}`,
        headers: getFileRequestHeader(),
        data: payload
    });

const updater = async (url, payload = {}, params = "") =>
    axios({
        method: "PUT",
        url: `${defaultSetting.mainHostUrl}${url}`,
        headers: getRequestHeader(),
        params: params,
        data: payload
    });

const destroyer = async (url, params = "") =>
    axios({
        method: "DELETE",
        url: `${defaultSetting.mainHostUrl}${url}`,
        headers: getRequestHeader(),
        params: params
    });

const createAgent = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/company`,
        headers: defaultSetting.fileRequestHeader,
        data: payload
    });

const createBranch = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/branch`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const createMerchant = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/merchant`,
        headers: defaultSetting.fileRequestHeader,
        data: payload
    });

const updateMerchant = async (payload, id) => 
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/merchant/${id}`,
        headers: defaultSetting.fileRequestHeader,
        data: payload
    });

const pullBranch = async () =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/branch/all`,
        headers: defaultSetting.requestHeader
    });

const pullAgent = async (page = 1) =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/agent/`,
        headers: defaultSetting.requestHeader,
        params: {
            page: page
        }
    });

const createLabel = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/label`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const login = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/login`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const createAgentOwner = async (payload, companyId) =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/company/${companyId}/owner`,
        headers: defaultSetting.fileRequestHeader,
        data: payload
    });

const createQuestion = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/qanda`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const pullQuestion = async id =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/qanda/${id}`,
        headers: defaultSetting.requestHeader
    });

const updateQuestion = async (payload, id) =>
    axios({
        method: "PUT",
        url: `${defaultSetting.mainHostUrl}/api/qanda/${id}`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const pullCodPending = async () =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/cod-pending`,
        headers: defaultSetting.requestHeader
    });

const createMessage = async payload =>
    axios({
        method: "POST",
        url: `${defaultSetting.mainHostUrl}/api/send-message`,
        headers: defaultSetting.requestHeader,
        data: payload
    });

const pullContactList = async () =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/chat/user-lists`,
        headers: defaultSetting.requestHeader
    });

const pullGroupList = async () =>
    axios({
        method: "GET",
        url: `${defaultSetting.mainHostUrl}/api/chat/group-lists`,
        headers: defaultSetting.requestHeader
    });
    
export default {
    puller,
    poster,
    filePoster,
    destroyer,
    updater,
    createAgent,
    createAgentOwner,
    createBranch,
    createMerchant,
    updateMerchant,
    createLabel,
    createQuestion,
    pullQuestion,
    updateQuestion,
    pullBranch,
    pullAgent,
    pullCodPending,
    login,
    createMessage,
    pullContactList,
    pullGroupList
};
